import entity from './entity';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const reducer = (state = ReduxRestEntity.initialState, action = {}) => {
  switch (action.type) {
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
